"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.replace");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _auth = require("@/utils/auth");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      role: {}
    };
  },
  computed: {
    userRoles: function userRoles() {
      return this.$store.getters.userRoles;
    }
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var roleType;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$store.commit('company/setOptionValue', null);

            case 2:
              _context.next = 4;
              return this.$store.dispatch('company/getRoles');

            case 4:
              _context.next = 6;
              return (0, _auth.getUserPermission)();

            case 6:
              roleType = _context.sent;

              if (roleType) {
                this.role = JSON.parse(roleType);
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    goToIndex: function goToIndex() {
      this.$router.replace({
        name: 'ProfileIndex'
      });
    },
    goToCreate: function goToCreate() {
      this.$router.replace({
        name: 'CreateRole'
      });
    },
    goToDetail: function goToDetail(data) {
      this.$router.replace({
        name: 'EditRole',
        params: {
          id: data
        }
      });
    }
  }
};
exports.default = _default;